/** @type {import('@nuxt/types').Middleware} */
const authMiddleware = async function({ app }) {
    if (!app.$tidalAuth.isLoggedIn()) {
        return app.errorUnauthorized();
    }
};

export default authMiddleware;
